import SimpleDate from 'app/common/classes/simple-date'
import toFixedValue from 'app/common/lib/toFixedValue'

import {
  EncashmentsSummaryType,
  EncashmentsStatusType,
  EncashmentsDetailsType,
  StatusesType,
  isEncashmentsStatusType,
} from 'app/dataTypes/reports/data'

import {
  ApiRowEncashment,
  ApiRowSummary,
  ApiStatusesType,
  dateFormat,
  dateTimeFormat,
  statusParams,
} from './types'

export const getStatusKey = (keyStatus: number): EncashmentsStatusType | null => {
  const newKey = statusParams[keyStatus.toString() as keyof typeof statusParams]
  if (isEncashmentsStatusType(newKey)) {
    return newKey
  }
  return null
}
export const convertStatuses = (apiStatuses: ApiStatusesType) => {
  return Object.entries(apiStatuses).reduce((acc, [key, value]) => {
    const newKey = statusParams[key as keyof typeof statusParams]
    if (isEncashmentsStatusType(newKey)) {
      acc[newKey] = toFixedValue(value)
    }
    return acc
  }, {} as StatusesType)
}

export const converRowSummary = (apiRowSummary: ApiRowSummary): EncashmentsSummaryType => {
  const {
    school_id: schoolId,
    school_title: schoolTitle,
    building_title: buildingTitle,
    sale_point_id: salePointId,
    sale_point_title: salePointTitle,
    status,
    comment,
    balance_at_the_beginning: balanceAtTheBeginning,
    revenue,
    collected,
    balance_at_the_end: balanceAtTheEnd,
    encashments_count: encashmentsCount,
    pending_dates: pendingDates,
  } = apiRowSummary

  return {
    schoolId: schoolId.toString(),
    schoolTitle,
    buildingTitle,
    salePointId: salePointId.toString(),
    salePointTitle,
    status: getStatusKey(status),
    comment,
    balanceAtTheBeginning: toFixedValue(balanceAtTheBeginning),
    revenue: toFixedValue(revenue),
    collected: toFixedValue(collected),
    balanceAtTheEnd: toFixedValue(balanceAtTheEnd),
    encashmentsCount,
    pendingDates: pendingDates.map((date) => new SimpleDate(date, dateFormat)),
  }
}

export const converRowEncashments = (
  apiRowEncashments: Array<ApiRowEncashment>,
): Array<EncashmentsDetailsType> => {
  return apiRowEncashments.map((encashmentItem) => {
    const {
      id,
      time,
      balance_at_the_beginning: balanceAtTheBeginning,
      revenue,
      collected,
      balance_at_the_end: balanceAtTheEnd,
    } = encashmentItem
    return {
      id: id.toString(),
      time: new SimpleDate(time, dateTimeFormat),
      balanceAtTheBeginning: toFixedValue(balanceAtTheBeginning),
      revenue: toFixedValue(revenue),
      collected: toFixedValue(collected),
      balanceAtTheEnd: toFixedValue(balanceAtTheEnd),
    }
  })
}
